import {
  RESET_INFORMED_CONSENT_STATUS,
  SET_CLIENT_INFORMED_CONSENT_STATUS,
  SET_IS_CLIENT_INFORMED_CONSENT_SHARED,
  SET_IS_PARTNER_INFORMED_CONSENT_SHARED,
  SET_LATEST_SESSION_NUMBER,
  SET_PARTNER_INFORMED_CONSENT_STATUS,
} from "../Actions/types";

const INITIAL_STATE = {};

let informedConsentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_INFORMED_CONSENT_STATUS:
      return INITIAL_STATE;
    case SET_CLIENT_INFORMED_CONSENT_STATUS:
      return { ...state, clientInformedConsentStatus: action.payload };
    case SET_PARTNER_INFORMED_CONSENT_STATUS:
      return { ...state, partnerInformedConsentStatus: action.payload };
    case SET_IS_CLIENT_INFORMED_CONSENT_SHARED:
      return { ...state, isClientInformedConsentShared: action.payload };
    case SET_IS_PARTNER_INFORMED_CONSENT_SHARED:
      return { ...state, isPartnerInformedConsentShared: action.payload };
    case SET_LATEST_SESSION_NUMBER:
      return { ...state, latestSessionNumber: action.payload };
    default:
      return state;
  }
};

export default informedConsentReducer;
